var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ModalHeader from "../../UI/Modal/ModalHeader";
import Modal from "../../UI/Modal/Modal";
import { ModalCloseButton } from "../../UI/StandardButtons/StandardButtons";
const FormSubmissionExpandedViewModal = (_a) => {
    var { formFieldLabel, formFieldValue } = _a, modalProps = __rest(_a, ["formFieldLabel", "formFieldValue"]);
    return (_jsxs(Modal, Object.assign({}, modalProps, { size: "xl", children: [_jsx(ModalHeader, { title: formFieldLabel, closeModal: () => modalProps.onModalClosed() }), _jsx("div", { className: "modal-body p-4 text-break", children: formFieldValue }), _jsx("div", { className: "modal-footer", children: _jsx(ModalCloseButton, { onClick: () => modalProps.onModalClosed() }) })] })));
};
export default FormSubmissionExpandedViewModal;
